import {Component, Input, OnInit} from '@angular/core';
import {MyModalProvider} from "../../providers/my-modal/my-modal";

/**
 * Generated class for the ModalTypeInputAComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'modal-type-input-a',
  templateUrl: 'modal-type-input-a.html'
})
export class ModalTypeInputAComponent implements OnInit{

  @Input() data;

  title: string = '';

  inputStr: string;

  desc: string;

  constructor(private myModal: MyModalProvider) {
    console.log('Hello ModalTypeInputAComponent Component');
  }

  ngOnInit(): void {
    if(this.data){
      this.title = this.data.title;
      this.desc = this.data.desc;
      this.inputStr = this.data.start_value;
    }
  }

  public confirm(){
    if(this.data && this.data.callback){
      this.data.callback(this.inputStr);
    }
    this.myModal.dismiss();
  }

  cancel(){
    this.myModal.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/components/modal-type-input-a/modal-type-input-a.ts